import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function AdminForbiddenView() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Admin Reporting</CardTitle>
        <CardDescription>Admin, manager, or read-only admin role is required to view time clock reports.</CardDescription>
      </CardHeader>
    </Card>
  );
}
